<div class="ted-chat">
  <div #messagesContainer class="ted-messages">
    @for (message of messages(); track $index) {
      @if (message.type === 'user') {
        <div class="message-row user-row">
          <div class="bubble user-bubble">{{ message.content }}</div>
          <span class="msg-time">{{ message.timestamp | date: 'h:mm a' }}</span>
        </div>
      } @else {
        <div class="message-row assistant-row">
          <div class="assistant-icon-wrap">
            <div class="ted-icon-wrap">
              <g99-icon-btn
                [icon]="tedIcon"
                [height]="16"
                [width]="16"
                [padding]="0"
                [backgroundColor]="'transparent'"
                [colorStrategy]="'none'"
                [isDisabled]="true"
              />
              <span class="ted-label">TED</span>
            </div>
          </div>
          <div class="bubble-wrap">
            <div class="bubble assistant-bubble">{{ message.content }}</div>
            <span class="msg-time">{{
              message.timestamp | date: 'h:mm a'
            }}</span>
          </div>
        </div>
      }
    }
    @if (isLoading()) {
      <div class="message-row assistant-row">
        <div class="assistant-icon-wrap">
          <div class="ted-icon-wrap">
            <g99-icon-btn
              [icon]="tedIcon"
              [height]="16"
              [width]="16"
              [padding]="0"
              [backgroundColor]="'transparent'"
              [colorStrategy]="'none'"
              [isDisabled]="true"
            />
            <span class="ted-label">TED</span>
          </div>
        </div>
        <div class="bubble assistant-bubble typing-bubble">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    }
  </div>
  <div class="ted-input-area">
    <input
      class="ted-input"
      type="text"
      placeholder="Ask Ted about your data..."
      [value]="chatInput()"
      [disabled]="isLoading()"
      (input)="onInputChange($event)"
      (keypress)="onKeyPress($event)"
    />
    <button
      class="ted-send-btn"
      type="button"
      aria-label="Send"
      [disabled]="isLoading() || !chatInput().trim()"
      (click)="onSend()"
    >
      <g99-icon-btn
        [icon]="sendIcon"
        [height]="16"
        [width]="16"
        [padding]="0"
        [backgroundColor]="'transparent'"
        [color]="'#ffffff'"
        [colorStrategy]="'both'"
        [isDisabled]="true"
      />
    </button>
  </div>
</div>
